import { Col } from "react-bootstrap"
import css from './styles.module.css'
import dayjs from "dayjs"

export default function PainelDocumentosPendentes({ documentos, loading, title }:iProps) {
    if (loading) {
        return (
            <div>

            </div>
        )
    }

    let documentos_left:any[] = []
    for (let i in documentos) {
        if (Number(i) % 2 === 1) {
            documentos_left.push(documentos[i])
        }
    }
    let documentos_right:any[] = []
    for (let i in documentos) {
        if (Number(i) % 2 === 0) {
            documentos_right.push(documentos[i])
        }
    }
    if (documentos_right.length > documentos_left.length) {
        documentos_left.push(documentos_right.pop())
    }
    const PADDING_DOCS = "5px"
    return (
        <div className={css.documentos}>
            <h1 className="titleMain">{title} ({documentos.length})</h1>
            <div className="div-row" style={{ alignItems: "start" }}>
                <Col className="col-6" style={{paddingRight: PADDING_DOCS,}}>
                    {
                        documentos_left.map((documento, idx, dados) => {
                            let data_assinado = <span></span>
                            if (documento.data_assinado !== null) {
                                data_assinado = <span className={css.documento_data_finalizado}>Finalizado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}</span>
                            }
                            return (
                                <div key={idx} className={css.documento} style={idx === 0 ? {borderTop: "1px solid lightgrey"} : {}} onClick={(event) => { handleClickDocumento(event.button, documento.codigo, event) }} onMouseUp={(event) => { handleClickDocumento(event.button, documento.codigo, event) }} onMouseDown={(event) => { if (event.button === 1) { event.preventDefault(); event.stopPropagation() } }}>
                                    <Col className="col-7">
                                        <p className={css.documento_nome}>{documento.nome}</p>
                                        <p className={css.documento_criacao}>#{documento.id} Criado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}{data_assinado}</p>
                                        <p>Por {documento.id_usuario === null ? "Não informado" : documento.id_usuario.nome}</p>
                                        <br></br>
                                        <DocumentoStatus id_status={documento.id_status.id_status} status={documento.id_status.descricao} lixeira={0} />
                                    </Col>
                                    <Col className="col-5">
                                        <p className={css.signatarios_title}>Assinaturas</p>
                                        <ListaUsuarioAssinaturas assinaturas={documento.signatarios} />
                                    </Col>
                                </div>
                            )
                        })
                    }
                </Col>
                <Col className="col-6" style={{paddingLeft: PADDING_DOCS,}}>
                    {
                        documentos_right.map((documento, idx, dados) => {
                            let data_assinado = <span></span>
                            if (documento.data_assinado !== null) {
                                data_assinado = <span className={css.documento_data_finalizado}>Finalizado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}</span>
                            }
                            return (
                                <div key={idx} className={css.documento} style={idx === 0 ? {borderTop: "1px solid lightgrey"} : {}} onClick={(event) => { handleClickDocumento(event.button, documento.codigo, event) }} onMouseUp={(event) => { handleClickDocumento(event.button, documento.codigo, event) }} onMouseDown={(event) => { if (event.button === 1) { event.preventDefault(); event.stopPropagation() } }}>
                                    <Col className="col-7">
                                        <p className={css.documento_nome}>{documento.nome}</p>
                                        <p className={css.documento_criacao}>#{documento.id} Criado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}{data_assinado}</p>
                                        <p>Por {documento.id_usuario === null ? "Não informado" : documento.id_usuario.nome}</p>
                                        <br></br>
                                        <DocumentoStatus id_status={documento.id_status.id_status} status={documento.id_status.descricao} lixeira={0} />
                                    </Col>
                                    <Col className="col-5">
                                        <p className={css.signatarios_title}>Assinaturas</p>
                                        <ListaUsuarioAssinaturas assinaturas={documento.signatarios} />
                                    </Col>
                                </div>
                            )
                        })
                    }
                </Col>
            </div>
        </div>
    )

    function handleClickDocumento(mouseClick: number, codigo: string, event:any) {
        const link = `/documento?id=${codigo}`
        if (mouseClick === 0) {
            window.location.href = link
        }
        if (mouseClick === 1) {
            event.preventDefault()
            event.stopPropagation()
            window.open(link)
        }
    }
}
interface iProps {
    loading: boolean
    documentos: any[]
    title: string
}

export function ListaUsuarioAssinaturas({ assinaturas }:iPropsAssinaturas) {
    if (assinaturas.length === 0) {
        return (
            <div>
                <p>Não foi informado signatários</p>
            </div>
        )
    }

    return (
        <div>
            {
                assinaturas.filter(reg => reg.id_funcao === 1).map((signatario, idx, dados) => {
                    let color = "#6c757d"
                    if (signatario.data_ultima_visualizacao != null) {
                        color = "#f0a202"
                    }
                    if (signatario.data_assinado != null) {
                        color = "#40bf4b"
                    }
                    if (signatario.data_recusado != null) {
                        color = "#b80220"
                    }
                    return (
                        <div key={idx} className={css.div_signatarios}>
                            <span className="material-symbols-outlined" style={{ fontSize: "10px", margin: "0px 8px 0px 0px", backgroundColor: color, borderRadius: "10px", color: color }}>
                                    circle
                            </span>
                            <p className={css.signatarios_nome}>
                                {signatario.nome_completo}
                            </p>
                        </div>
                    )
                })
            }
        </div>
    )
}
interface iPropsAssinaturas {
    assinaturas: any[]
}

export function DocumentoStatus({ id_status, status, lixeira }:iPropsStatus) {
    let backgroundColor = "#f0a202"
    let color = "white"
    let status_aux = status
    if (id_status === 2) {
        backgroundColor = "#40bf4b"
        color = "white"
    }
    if (id_status === 3) {
        backgroundColor = "#b80220"
        color = "white"
    }
    if (lixeira === 1) { 
        backgroundColor = "#9D4F51"
        color = "white"
        status_aux = "Excluído"
    }
    return (
        <p className={css.documento_status} style={{ backgroundColor: backgroundColor, color: color, }}>{status_aux}</p>
    )
}
interface iPropsStatus {
    id_status: number
    status: string
    lixeira: number
}